
    var riot = require('riot')
    //src: starling/src/tags/perspective-annotation-popover.html
riot.tag2('perspective-annotation-popover',
  '<popover ref="popover" title="Explain" position="right"> <p>Add a note about <b>{parent.annotationTag ? parent.annotationTag.truncatedViewTitle() : \'\'}</b> from the perspective of <b>{parent.annotationTag ? parent.annotationTag.truncatedPointTitle() : \'\'}</b></p> <span onclick="{parent.openPerspectivesOnboarding}" class="popover_link">Learn more…</span> </popover>',
  '',
  'ref="main"', function(opts) {
'use strict';

var _this = this;

this.canvas = opts.canvas;
this.canvas.perspectiveAnnotationPopoverTag = this;

var shuttle = function shuttle(localRef, remoteRef) {
  if (!(localRef && localRef.parentNode && remoteRef)) {
    return;
  }
  localRef.parentNode.removeChild(localRef);
  remoteRef.appendChild(localRef);
  localRef.classList.remove('hidden');
};

this.on('mount', function () {
  _this.refs.popover.on('close', _this.popoverClose);
});

this.summon = function (_ref) {
  var annotationTag = _ref.annotationTag;

  _this.hide();
  shuttle(_this.refs.main, annotationTag.refs.annotationContainer);
  _this.annotationTag = annotationTag;
  _this.update();
  _this.refs.popover.show();
};

this.hide = function () {
  _this.refs.popover.hide();
  _this.annotationTag = null;
};

this.openPerspectivesOnboarding = function (e) {
  e.stopPropagation();
  _this.canvas.openSidebar('user-guide');
  _this.canvas.userGuideTag.openItem('create-p');
  _this.hide();
};

this.popoverClose = function () {
  if (window.user) {
    if (!window.user.closed_perspectives_annotation_tooltip) {
      window.user.closed_perspectives_annotation_tooltip = 1;
      $.ajax({
        method: 'POST',
        url: '/api/users/display-flags/update',
        data: { closed_perspectives_annotation_tooltip: 1 }
      });
    }
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspective-annotation-popover')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspective-annotation-popover.html
// module id = 664
// module chunks = 0